<template>
    <div class="w-100">
        <single-query-input v-if="showSearch"
                            class="mt-2 mb-2"
                            front-size="1rem"
                            :value.sync="queryMaterial"
                            :query-loading="queryLoading"
                            :disable="exportLoading"
                            placeholder="Enter Material"
                            @doQuery="queryBom"></single-query-input>
        <div class="bg-white h-100" :class="showSearch?'table-cover':''">
            <mini-table ref="miniTable"
                        read-only
                        :items="bomList"
                        :fields="fields"
                        disable-first-index-column
                        enable-table-tree
                        entity-name="MaterialBom"
                        tree-id-name="component"
                        tree-level-name="level"
                        tree-parent-id-name="parentMaterial"
                        :default-expend-depth="expendDepth"
                        :addition-columns="enableComponentAddition?'component':null"
                        :enable-tree-check="enableCheck"
                        tree-check-mode="N"
                        @rowChecked="whenComponentChecked"
                        @linkClick="whenComponentClick">
                <template #leftHeader>
                    <slot name="leftHeader"></slot>
                </template>
                <template #header>
                    <template v-if="showSearch">
                        <b-nav pills small fill>
                            <template v-for="(item,index) of queriedMaterials">
                                <b-nav-item :key="index"
                                            class="nav-cover"
                                            :active="activeMaterial === item"
                                            @click="activeMaterial=item">
                                    {{ item }}
                                    <button type="button"
                                            class="close close-btn"
                                            @click="removeMaterial(item)"
                                            aria-label="关闭">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </b-nav-item>
                            </template>
                        </b-nav>

                        <b-form-checkbox v-if="queriedMaterials.length > 1"
                                         class="ml-auto mt-auto mb-auto" size="lg"
                                         v-model="exportSingleSheet">
                        </b-form-checkbox>
                    </template>
                </template>
                <template #rightHeader>
                    <template v-if="bomList.length > 0">
                        <mini-button loading-type="grow"
                                     :disable="queryLoading" :loading="exportLoading"
                                     @btnClick="downloadBom()">
                            导出BOM{{ exportSingleSheet && queriedMaterials.length > 1 ? '(单Sheet)' : '' }}
                        </mini-button>
                        <mini-button loading-type="grow"
                                     :disable="queryLoading"
                                     @btnClick="downloadBomDrawing()">
                            下载全部图纸
                        </mini-button>
                    </template>
                </template>
                <template #addition(component)="{row}">
                    <slot name="component" :row="row"></slot>
                </template>
            </mini-table>
        </div>

        <re-b-modal ref="drawings" header="图纸">
            <material-drawing-infos :material="currentMaterial" @none="$refs.drawings.hide()"></material-drawing-infos>
        </re-b-modal>
    </div>
</template>

<script>
import MiniTable from "@/components/common/mini-table/MiniTable.vue";
import emCommonUtilMixin from "@/mixin/em/common/stuffs/utils/emCommonUtilMixin";
import SingleQueryInput from "@/components/common/inputs/SingleQueryInput.vue";
import MiniButton from "@/components/common/buttons/MiniButton.vue";
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal.vue";
import drawingDownloadMixin from "@/views/sithMesII/pds/stuffs/drawing-download-mixin";
import MaterialDrawingInfos from "@/views/sithMesII/pds/stuffs/MaterialDrawingInfos.vue";

export default {
    name: "BomTree",
    mixins: [emCommonUtilMixin, drawingDownloadMixin],
    components: {MaterialDrawingInfos, ReBModal, MiniButton, SingleQueryInput, MiniTable},
    props: {
        material: String,
        parentMaterial: String,

        enableCheck: {
            type: Boolean,
            default: false
        },
        enableComponentAddition: {
            type: Boolean,
            default: false
        },
        expendDepth: {
            type: Number,
            default: 3
        },
    },
    data() {
        return {
            queryMaterial: '',
            batchQueryCount: 0,
            exportLoading: false,
            bomListMap: {},
            materialIdMap: {},
            activeMaterial: '',
            exportSingleSheet: false,

            enableDrawingQuery: false,

            currentMaterial: null
        };
    },
    computed: {
        showSearch() {
            return this.material === undefined || this.material == null || this.material === '';
        },
        queriedMaterials() {
            if (this.queryLoading) {
                //refresh
            }
            return Object.keys(this.bomListMap);
        },
        bomList() {
            let list = this.bomListMap[this.activeMaterial];
            return list ? list : [];
        },
        queryLoading() {
            return this.batchQueryCount > 0;
        },
        fields() {
            return [
                {key: 'material'},
                {key: 'level'},
                {key: 'item'},
                {key: 'component', isLink: this.enableDrawingQuery},
                {key: 'qty'},
                {key: 'bomUnit'},
                {key: 'ipt', label: 'IPT'},
                {key: 'pdt', label: 'PDT'},
                {key: 'chinese'},
                {key: 'longText'},
                {key: 'english'},
                {key: 'mtype', label: 'MType'},
                {key: 'purchaseType', label: 'E/F'},
                {key: 'mrp', label: 'MRP'},
                {key: 'ict', label: 'ICT'},
                {key: 'itemText'},
                {key: 'baseQuantity'},
            ]
        },
    },
    watch: {
        queryLoading(val) {
            if (!this.showSearch) {
                this.$refs.miniTable.changeLoading(val);
            }
        },
    },
    created() {
        if (this.material) {
            this.queryMaterial = this.material;
            this.queryBom();
        }
        if (this.$route.params.enableDrawingQuery) {
            this.enableDrawingQuery = true;
        }
    },
    methods: {
        queryBom() {
            if (this.queryLoading || this.exportLoading) {
                return;
            }
            let input = this.queryMaterial;
            let strings = input.split(new RegExp('[ ,;，]'));
            if (strings.length > 1) {
                for (let m of strings) {
                    this.queryMaterialBom(m, true);
                }
            } else {
                this.queryMaterialBom(input);
            }
        },
        queryMaterialBom(material, batch = false) {
            if (material) {
                this.batchQueryCount++;
                this.$store.dispatch('api/get', {
                    url: `${process.env.VUE_APP_SITHMES_II_URL}/materialBom/query/bomTree?material=${material}&parent=${this.parentMaterial}`
                }).then(response => {
                    if (response) {
                        for (let item of response) {
                            if (item.component === material) {
                                item._rowVariant = 'warning';
                            }
                            // 未指定父件时，根行取自任意一条父 BOM 行，其 Material/Item/Qty 属于那个父件，不展示
                            if (item.level === 0 && !this.parentMaterial) {
                                item.material = null;
                                item.item = null;
                                item.qty = null;
                            }
                        }
                        this.$set(this.bomListMap, material, response);
                        this.$set(this.materialIdMap, material, response[0].id);
                        if (!batch) {
                            this.activeMaterial = material;
                        }
                        this.$emit("gotBom")
                    } else {
                        this.$message.warning(`没有查询到 ${material} 的BOM信息`)
                        this.$emit("noBom")
                    }
                }).finally(() => this.batchQueryCount--);
            }
        },
        downloadBom() {
            if (this.queryMaterial) {
                this.exportLoading = true;
                this.downloadWithHeader(this.downloadBomExcelUrl(), 'ALL BOM.xlsx', () => this.exportLoading = false);
            }
        },
        downloadBomExcelUrl() {
            return process.env.VUE_APP_SITHMES_II_URL + "/materialBom/export/bom/excel?materialIds=" + this.getMaterialIds().join(",") + (this.exportSingleSheet ? '&singleSheet=true' : '');
        },
        removeMaterial(material) {
            this.$delete(this.bomListMap, material);
            this.$delete(this.materialIdMap, material);
        },
        getMaterialIds() {
            return Object.values(this.materialIdMap);
        },
        downloadBomDrawing() {
            const material = this.activeMaterial;
            if (!material) {
                this.$message.warning("没有可下载的物料");
                return;
            }
            this.$store.dispatch("drawingDownload/open", {
                materials: [material],
                scope: 2,           // 物流:最新采购规范
                module: "BOM Tree",
            });
        },
        whenComponentChecked(checkIds) {
            let idSet = new Set(checkIds);
            let tempList = [];
            for (let row of this.bomList) {
                if (idSet.has(row.id)) {
                    tempList.push(row.component);
                }
            }
            this.$emit('componentCheck', tempList);
        },
        initCheckedComponent(components) {
            if (this.enableCheck) {
                let componentSet = new Set(components);
                let tempList = [];
                for (let row of this.bomList) {
                    if (componentSet.has(row.component)) {
                        tempList.push(row.id);
                    }
                }
                this.$refs.miniTable.initCheckStatus(tempList);
            }
        },
        whenComponentClick({key, row}) {
            if (key === 'component') {
                this.currentMaterial = row.component;
                this.$refs.drawings.showModal();
            }
        },

    },
}
</script>


<style scoped>
.input-cover {
    font-size: 1rem;
}

.table-cover {
    height: calc(100vh - 180px) !important;
    max-height: 100% !important;
    border-radius: 7px;
}

.active {
    background-color: #e8eef6 !important;
    color: black !important;
}

.nav-cover {
    max-width: fit-content;
}

.close-btn {
    margin-left: 0.25rem;
    font-size: 0.8rem;
    text-shadow: 0 0 black;
    opacity: 0;
}

.nav-cover:hover .close-btn {
    color: red;
    opacity: 1;
}

.close-btn:hover {
    background-color: rgba(0, 0, 0, .2);
    border-radius: 30%;
}

::v-deep .custom-control-label {
    width: max-content !important;
}
</style>
